<div myPreloader class="preloaderbar hide"><span class="bar"></span></div>
@let curConfig = uiconfiguration | async;
@if (!isIframe) {
  <!-- Show main app only when fully loaded -->
  @if (curConfig === 'identitydirector') {
    @if (trialDaysRemaining !== null && trialDaysRemaining <= 14) {
      <div class="trial-warning-banner">
        <mat-icon>warning</mat-icon>
        Trial expires in {{ trialDaysRemaining }} day(s). Contact your administrator.
      </div>
    }
    <div
      id="app-main"
      class="app-main full-height"
      [ngClass]="{
        'fixed-header': true,
        'nav-collapsed': AppConfig.navCollapsed,
        'sidebar-lg': true,
      }"
    >
      <router-outlet></router-outlet>
    </div>
  }

  <!-- Show environment switch UI -->
  @if (curConfig === 'environmentswitch') {
    <div class="installer">
      @for (endpoint of environment.endpoints; track endpoint) {
        <button matButton="filled" (click)="connectToEndpoint(endpoint)">
          Connect to {{ endpoint.name }}
        </button>
      }
    </div>
  }

  <!-- Show trial expired screen -->
  @if (curConfig === 'trialexpired') {
    <div class="trial-expired-container">
      <div class="trial-expired-content">
        <mat-icon class="trial-expired-icon">hourglass_disabled</mat-icon>
        <h1>Trial Period Expired</h1>
        <p>
          Your trial period for Identity Director has ended. To continue using the application,
          please contact your administrator or visit
          <a [href]="AppConfig.productLink" target="_blank">{{ AppConfig.productLink }}</a>
          to obtain a license.
        </p>
        <p class="trial-expired-date">Trial expired on: {{ AppConfig.trialExpirationDate }}</p>
      </div>
    </div>
  }

  <!-- Show loading screen -->
  @if (curConfig === 'startup') {
    <div id="loader-container">
      <div class="smiley-loader">
        <svg viewBox="-200 -200 736 736" xmlns="http://www.w3.org/2000/svg">
          <g transform="translate(168, 168)">
            <g class="rotate-group">
              <g transform="rotate(90) translate(-138.82, -168.095)">
                <g class="winking-eye">
                  <path
                    class="dash"
                    d="M147,30.26V55.8c0,14.68-4.07,20.11-32.51,14L0.22,44.37V0Z"
                  />
                  <circle class="dot" cx="73.5" cy="43" r="44" />
                </g>
                <path
                  class="open-eye"
                  d="M233.19,21.68c25.32,0,44.45,21.94,44.45,46.7s-19.13,42.2-41.63,42.2c-25.88,0-44.45-22.5-44.45-47.26S210.13,21.68,233.19,21.68Z"
                />
                <path
                  class="mouth"
                  d="M270.21,146.84v85c0,73.34-39.37,104.36-110.4,104.36C79.52,336.19,0,298.61,0,197.86V121.69ZM42.46,193.93c1.09,78.23,71.27,83.64,119.91,83.64,37.06,0,63.21-19.32,64.61-48.89V187.42L42.46,172.56v21.37Z"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
      <div class="identity-text">Identity Director</div>
      <div class="loading-text">
        <span>Loading</span>
        <span class="dots">
          <span class="dot1">.</span>
          <span class="dot2">.</span>
          <span class="dot3">.</span>
        </span>
      </div>
    </div>
  }
}
